<template>
  <div class="point">
    <span>
      <slot name="k">{{ k }}</slot>
    </span>
    <strong class="text-primary">
      <slot name="v">{{ v }}</slot>
    </strong>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  k?: string;
  v?: string;
}>();
</script>

<style scoped lang="scss">
.point {
  flex: 1;
  position: relative;
  padding-inline-start: var(--space-4);
  &::after {
    content: '';
    position: absolute;
    inset-inline-start: 0;
    top: 7%;
    bottom: 10%;
    width: 2px;
    background-color: rgb(var(--v-theme-tertiary)); 
  }

  span {
    display: block;
    font-size: 18px;
  }
  strong {
    font-size: 22px;
  }
}

@media (max-width: 850px) {
  .point {
    align-self: center;

    strong {
      font-size: 20px;
    }

    h3 {
      font-size: 24px;
      margin-bottom: 0 !important;
    }
  }
}
</style>